import { hasAdminModuleAccess } from "./roleHelper";

const normalizeModuleKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/_/g, "-");

export const ADMIN_MENU_SECTIONS = [
  {
    label: "Tableau de bord",
    items: [
      {
        title: "Tableau de bord",
        path: "/appli/dashboard",
        matchPaths: ["/appli/dashboard"],
        moduleKey: "dashboard",
      },
    ],
  },
  {
    label: "Contenus",
    items: [
      {
        title: "Actualités",
        path: "/appli/news",
        matchPaths: ["/appli/news"],
        moduleKey: "news",
      },
      {
        title: "Agenda / Événements",
        path: "/appli/events",
        matchPaths: ["/appli/events"],
        moduleKey: "events",
      },
      {
        title: "Publications",
        path: "/appli/publications",
        matchPaths: ["/appli/publications"],
        moduleKey: "publications",
      },
      {
        title: "Grands Projets",
        path: "/appli/projets",
        matchPaths: ["/appli/projets"],
        moduleKey: "projets",
      },
      {
        title: "Associations",
        path: "/appli/associations",
        matchPaths: ["/appli/associations"],
        moduleKey: "associations",
      },
      {
        title: "Commerces",
        path: "/appli/commerces",
        matchPaths: ["/appli/commerces"],
        moduleKey: "commerces",
      },
      {
        title: "Services municipaux",
        path: "/appli/services-municipaux",
        matchPaths: ["/appli/services-municipaux"],
        moduleKey: "services-municipaux",
      },
      {
        title: "Trombinoscope",
        path: "/appli/trombinos",
        matchPaths: ["/appli/trombinos"],
        moduleKey: "trombinos",
      },
      {
        title: "Albums-Photos",
        path: "/appli/albums-photos",
        matchPaths: ["/appli/albums-photos"],
        moduleKey: "albums-photos",
      },
    ],
  },
  {
    label: "CMS & Navigation",
    items: [
      {
        title: "Menus",
        path: "/appli/menus",
        matchPaths: ["/appli/menus"],
        moduleKey: "menus",
      },
      {
        title: "Pages (CMS)",
        path: "/appli/pages",
        matchPaths: ["/appli/pages"],
        moduleKey: "pages",
      },
      {
        title: "Médiathèque",
        path: "/appli/photos",
        matchPaths: ["/appli/photos"],
        moduleKey: "photos",
      },
    ],
  },
  {
    label: "Système",
    items: [
      {
        title: "Utilisateurs",
        path: "/appli/utilisateurs",
        matchPaths: ["/appli/utilisateurs"],
        moduleKey: "utilisateurs",
      },
      {
        title: "Paramètres du site",
        path: "/appli/parametres",
        matchPaths: ["/appli/parametres"],
        moduleKey: "parametres",
      },
      {
        title: "Abonnement-Requêtes",
        path: "/appli/abonnement",
        matchPaths: ["/appli/abonnement"],
        moduleKey: "abonnement",
      },
    ],
  },
];

export function isMenuActive(pathname, item) {
  return (item.matchPaths || [item.path]).some(
    (basePath) =>
      pathname === basePath ||
      pathname.startsWith(`${basePath}/`) ||
      pathname.startsWith(`${basePath}?`),
  );
}

export function getVisibleAdminSections(user) {
  if (!user) return [];

  if (Number(user?.role_id) === 1) {
    return ADMIN_MENU_SECTIONS;
  }

  return ADMIN_MENU_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter((item) =>
      hasAdminModuleAccess(user, normalizeModuleKey(item.moduleKey), "view"),
    ),
  })).filter((section) => section.items.length > 0);
}

export function getFirstAccessibleAdminPath(user) {
  if (!user) return null;

  if (Number(user?.role_id) === 1) {
    return "/appli/dashboard";
  }

  const firstItem = getVisibleAdminSections(user).flatMap(
    (section) => section.items,
  )[0];

  return firstItem?.path || null;
}

export function isAllowedAdminPath(user, pathname) {
  if (!user) return false;

  if (Number(user?.role_id) === 1) {
    return true;
  }

  const visibleSections = getVisibleAdminSections(user);

  return visibleSections.some((section) =>
    section.items.some((item) => isMenuActive(pathname, item)),
  );
}
